module.exports = __webpack_public_path__ + "static/img/fr.cc4d943d.svg";